<nav class="navbar navbar-expand-md navbar-light bg-light pb-3 pb-md-0">
    <div class="container position-relative">
        <div class="d-flex flex-column">
            <a class="navbar-brand" href="/?merchantId={{merchantId}}">
                <img [src]="logo" alt="Logo" height="50" (error)="onLogoError()">
            </a>
        </div>
        <button class="navbar-toggler" type="button" (click)="toggleMenu()">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse flex-column align-items-end pb-1" [ngClass]="{'show': isMenuOpen}">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link fw-bold" href="/?merchantId={{merchantId}}">Home</a>
                </li>
            </ul>
            <div class="d-flex">
                <img class="img-fluid fdic-logo" src="/assets/image/fdic-digital-sign.svg" alt="FDIC Digital Sign">
            </div>
        </div>
        <div class="d-flex position-absolute fdic-logo-mobile d-md-none ">
            <img class="img-fluid" src="/assets/image/fdic-digital-sign.svg" alt="FDIC Digital Sign">
        </div>
    </div>
</nav>
